module.exports = {
  // 后台地址
  // BACKEND_URL: 'http://dev.beyondinfo.com.cn:20800',
  // BACKEND_URL: 'http://192.168.3.124:2080',
  // BACKEND_URL: 'http://116.62.127.81:6105',
  // BACKEND_URL: 'http://192.168.3.151:4080',
  BACKEND_URL: 'https://47.108.223.121:2008',
  // BACKEND_URL: 'http://xm.beyondinfo.com.cn:7106',
  // BACKEND_URL: 'http://47.112.161.101:2080',
  ACTIVITI_URL: 'http://127.0.0.1:3080',
  HXIM_LOGIN: false,
  // 导出入库单
  EXPORT_STORAGE_IN_ORDER: '/vue/storage/export-in-order',
  // 导出入库单
  EXPORT_STORAGE_OUT_ORDER: '/vue/storage/export-out-order',
  // 导出来程行程
  EXPORT_CAR_JOURNEY_COME: '/vue/medical/journey-export-come-excel',
  // 导出来程派车
  EXPORT_CAR_APPLY_COME: '/vue/medical/car-apply-export-come-excel',
  // 导出返程派车
  EXPORT_CAR_APPLY_BACK: '/vue/medical/car-apply-export-back-excel',
  // 疗养部门类型
  MEDICAL_DEPT_UNIT_TYPE: 0,
  // 登录页面
  LOGIN_PAGE_NAME: 'home',

  AUTH_PAGE_NAME: 'authPage',
  // 导出活动报名列表
  EXPORT_ACTIVITY_SIGN_UP_EXCEL: '/vue/activity/export-sign-up-excel',
  // 导出疗养助手
  EXPORT_MEDICAL_REQUEST_SERVICE_EXCEL: '/vue/medical/requestservice-export-excel',
  // 导入食谱
  IMPORT_RECIPE_URL: '/vue/recipe/recipeinfo-import-recipe-by-excel',
  // 导入疗养员
  IMPORT_PATIENT_URL: '/vue/medical/medicalmain-import-patient-by-excel',
  // 导入房间
  IMPORT_BUILDING_ROOM_URL: '/vue/building/import-by-excel',
  // 导出送餐表
  EXPORT_ORDER_PACKAGE_EXCEL: '/vue/recipe/export-order-package-excel',
  // 导出未点餐送餐表
  EXPORT_INCLUDE_UNORDER_PACKAGE_EXCEL: '/vue/medical/export-order-package-excel',
  // 导出订餐统计表
  EXPORT_ORDER_RECIPE_EXCEL: '/vue/recipe/export-order-recipe-excel',
  // 导出未点餐统计表
  EXPORT_UNORDER_ROOM_EXCEL: '/vue/recipe/export-unorder-room-excel',
  // 导出体温报表
  EXPORT_MEDICAL_TEMPERATURE_URL: '/vue/medical/datatemperature-export-excel',
  // 导出监测个案报表
  EXPORT_MEDICAL_HEALTH_MONITOR_URL: '/vue/medical/monitor-export-excel',
  // 导出集中医学观察日报
  EXPORT_MEDICAL_MONITOR_STATS_URL: '/vue/mdata/monitorstats-export-excel',
  // app版本下载二维码
  DOWNLOAD_APP_URL: '/vue/system/mobileversion-get-qrcode',
  // 高亮流程图地址
  GET_HIGH_LIGHT_IMG: '/vue/workflow/actProcessIns/getHighlightImg',
  // 导出流程图地址
  XML_EXPORT_URL: '/vue/workflow/actProcess/export',
  // 导出模型地址
  MODEL_EXPORT_URL: '/vue/workflow/actModel/export',
  // 通过文件部署
  DEPLOY_BY_FILE_URL: '/vue/workflow/actModel/deployByFile',
  // 大数据展示平台地址
  // 'http://www.hightopo.com/demo/smart-building-pc/'
  DATAV_URL: 'http://www.edywin.com:8080/parking/index.html',
  FULL_SCREEN: true,
  // OAUTH2_URL: "http://127.0.0.1:2080/vue/token/authUrl?url=" + decodeURIComponent("https://127.0.0.1:8080/home/index")
};
